import { put, select } from "typed-redux-saga";
import { rootActions } from "../reducers/root.slice";
import { setStatus } from "../dom-utils";
import RowUtils from "../utils/RowUtils";
import { selectRootState } from "../selectors";

function* revertToCategorical() {
  const { rows, leftPanel, rightPanel, continuousColumns, categoricalColumns } =
    yield* select(selectRootState);

  const { selectedColumn } = leftPanel;
  const { categoricalColumnsAsContinuous } = rightPanel;

  if (!selectedColumn) {
    throw new Error("No column selected");
  }

  setStatus("Reverting to categorical ...");

  const newRows = rows.map((row) => {
    const newValue = RowUtils.getValue(row, selectedColumn);

    if (!newValue) {
      return row;
    }

    const mappedValue =
      categoricalColumnsAsContinuous[selectedColumn][Number(newValue)];

    return {
      ...row,
      [selectedColumn]: mappedValue,
    };
  });

  const newCategoricalColumnsAsContinuous = {
    ...categoricalColumnsAsContinuous,
  };

  delete newCategoricalColumnsAsContinuous[selectedColumn];

  yield* put(
    rootActions.revertToCategoricalDone({
      rows: newRows,
      categoricalColumnsAsContinuous: newCategoricalColumnsAsContinuous,
      continuousColumns: continuousColumns.filter((c) => c !== selectedColumn),
      categoricalColumns: [...categoricalColumns, selectedColumn],
    })
  );

  yield* put(rootActions.generateGraph());
}

export default revertToCategorical;
